import { Box, Button, Container, Typography } from '@mui/material';
import { Check } from '@mui/icons-material';
import { ImageUploader, SubheaderV2 } from 'components';
import ClubForm from 'features/clubs/ClubForm';
import { useAlerts, useClubs, useUploadFileInMemory } from 'hooks';
import React, { useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { validateClub } from 'validations/clubs';

const ClubEdit = ({ ...props }) => {
	const navigate = useNavigate();
	const { id } = useParams();
	const { memoryFile, removeFile, handleUploadFile } = useUploadFileInMemory();
	const { showAlertSuccess, showAlertError } = useAlerts();
	const { club, handleChange, updateClub, findClub } = useClubs({
		id: id
	});

	const handleSaveClick = async () => {
		const valid = validateClub(club);
		if (valid.isValid) {
			await updateClub(club, memoryFile);
			showAlertSuccess('Club has been updated');
			navigate('/clubs');
		} else {
			valid.messages.map((m) => showAlertError(m));
		}
	};

	useEffect(() => {
		if (id) findClub(id);
	}, [id, findClub]);

	const handleDelete = async () => {
		removeFile();
	};

	return (
		<>
			<SubheaderV2
				title="Edit Club"
				buttons={[
					<Button
						color="primary"
						variant="contained"
						startIcon={<Check />}
						onClick={handleSaveClick}
					>
						Save Changes
					</Button>
				]}
			/>
			<Container>
				<Box p={4}>
					<ClubForm club={club} handleChange={handleChange} />
				</Box>
			</Container>
		</>
	);
};

export default ClubEdit;
